const styles = {
    subPageTitle: {
        textAlign: "center",
        borderBottom: "2px solid rgb(204, 204, 204)",
        padding: 15,
        color: "rgb(80, 80, 80)"
    },
    inputStyle: {
        width: 400,
    },
    stackRow: {
        margin: "auto"
    },
    stackColumn: {
        margin: "auto"
    },
    bold: {
        fontWeight: "bold",
    },
    red: {
        color: "#e74c3c"
    },
    green: {
        color: "#27ae60"
    },
    orange: {
        color: "#e67e22"
    },
    link: {
        textDecoration: "none",
        color: "#1976d2"
    }
};

export default styles;